module.exports = __webpack_public_path__ + "assets/c638c956565abfa089fb17af15a18f9a.svg";